import {
  useLayoutEffect,
  useState,
  useEffect,
  useCallback,
  useRef,
} from "react";
import { SelectBox, Template, TextArea, TextBox } from "devextreme-react";
import DataGrid, {
  Column,
  Export,
  HeaderFilter,
  Pager,
  Paging,
  SearchPanel,
} from "devextreme-react/data-grid";
import { AssetSubStatus, DefaultDateFormat } from "../../../helper/fixcode";
import { assetService } from "../../../apis/apiServices/Asset";
import { useNavigate } from "react-router-dom";
import "./../../../App.css";
import { useSelector } from "react-redux";
import moment from "moment";
import Modal from "react-modal";
import { Icon } from "@iconify/react";
import { askConfirmation, showResponseMessage } from "../../../helper/message";
import { vishwamApi } from "../../../apis/apiServices/VishwamApi";
import { Loader } from "../../Shared/PageLoader";

export default function AssetAcknowledgeComponent(props) {
  const navigate = useNavigate();
  const user = useSelector((state) => state.user.data);
  const [state, setState] = useState({
    isAcknowledged: false,
    isAcknowledgeModalOpen: false,
    rowData: null,
    assetAcknowledgeConditionId: 0,
    recievedByUserId: user?.userId ?? 0,
    recievedByUserName: "",
    acknowledgeNote: "",
    cust1DeptId: 0,
    cust2DeptId: 0,
    cust3DeptId: 0,
    assignDeptId: 0,
    cust1UserId: 0,
    cust2UserId: 0,
    cust3UserId: 0,
    assignUserId: 0,
    assignTypeId: 0,
    assignVendorId: 0,
    assignVendorName: "",
    assignValidUserId: 0,
    assetAssignedId: 0,
    assetAssignDeptId: 0,
    assetAssignTypeId: 0,
    isCompleteLoading: false,
    loadingMessage: "",
  });
  const [assetAcknowledgeAttachment, setAssetAcknowledgeAttachment] = useState({
    fileName: "",
    fileType: "",
    fileSize: 0,
    fileData: "",
  });
  const [errors, setErrors] = useState({
    assetAcknowledgeConditionValidation: "",
    recievedByUserValidation: "",
    acknowledgeNoteValidation: "",
    acknowledgeAttachmentValidation: "",
    cust1DeptValidation: "",
    cust2DeptValidation: "",
    cust3DeptValidation: "",
    assignDeptValidation: "",
    cust1UserValidation: "",
    cust2UserValidation: "",
    cust3UserValidation: "",
    assignUserValidation: "",
    assignTypeValidation: "",
    assignVendorValidation: "",
    assignVendorNameValidation: "",
  });
  const [assetAcknowledgeDataSourceLst, setAssetAcknowledgeDataSourceLst] =
    useState([]);
  const [
    assetAcknowledgeConditionDropdown,
    setAssetAcknowledgeConditionDropdown,
  ] = useState([]);
  const [recievedByUserDropdown, setRecievedByUserDropdown] = useState([]);
  const [custodian1DepartmentDropdown, setCustodian1DepartmentDropdown] =
    useState([]);
  const [custodian1UserDropdown, setCustodian1UserDropdown] = useState([]);
  const [custodian2DepartmentDropdown, setCustodian2DepartmentDropdown] =
    useState([]);
  const [custodian2UserDropdown, setCustodian2UserDropdown] = useState([]);
  const [custodian3DepartmentDropdown, setCustodian3DepartmentDropdown] =
    useState([]);
  const [custodian3UserDropdown, setCustodian3UserDropdown] = useState([]);

  const [assignDepartmentDropdown, setAssignDepartmentDropdown] = useState([]);
  const [assignUserDropdown, setAssignUserDropdown] = useState([]);
  const [assignTypeDropdown, setAssignTypeDropdown] = useState([]);
  const [assignedVendorDropdown, setassignedVendorDropdown] = useState([]);
  const refDataGrid = useRef(null);

  useLayoutEffect(() => {
    document.querySelector("#pageTitle").innerHTML = `Asset Acknowledgement`;
  }, []);

  let isUseEffectRendered = false;
  useEffect(() => {
    const controller = new AbortController();
    try {
      if (isUseEffectRendered) {
        return;
      }
      fetchApiOnPageLoad();
      return () => {
        controller.abort();
        isUseEffectRendered = true;
      };
    } catch (error) {
      console.log(error);
    }
  }, []);

  const fetchApiOnPageLoad = useCallback(async () => {
    try {
      setState((prevState) => ({
        ...prevState,
        isCompleteLoading: true,
      }));
      await getAssetAcknowledgeLst(0, user?.userId);
      setState((prevState) => ({
        ...prevState,
        isCompleteLoading: false,
      }));
    } catch (error) {
      console.log(error);
      setState((prevState) => ({
        ...prevState,
        isCompleteLoading: false,
      }));
    }
  }, []);

  const getAssetAcknowledgeLst = async (assetAcknowledgeId, userId) => {
    try {
      //refDataGrid?.current?.instance?.beginCustomLoading();
      const response = await assetService.getAssetAcknowledge(
        assetAcknowledgeId,
        userId
      );      
      setAssetAcknowledgeDataSourceLst(
        response.data?.filter(
          (f) => f.statusId !== Number(AssetSubStatus.AssetAcknowledged)
        ) ?? []
      );
    } catch (error) {
      console.log(error);
    } finally {
      //refDataGrid?.current?.instance?.endCustomLoading();
    }
  };

  const getAssignTypeDropdown = async () => {
    try {
      const assignTypeList = [
        { id: 1, name: "Department" },
        { id: 2, name: "User" },
        { id: 3, name: "Vendor" },
      ];
      setAssignTypeDropdown(assignTypeList ?? []);
    } catch (error) {
      console.log(error);
    }
  };

  const debounce = (fn, delay) => {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => fn(...args), delay);
    };
  };

  const debouncedVendorSearch = useCallback(
    debounce((text) => {
      getAssignedVendorDropdown(text, state.assignVendorId);
    }, 500),
    []
  );

  const getAssignedVendorDropdown = async (searchText, vendorId) => {
    try {
      // const response = await vishwamApi.getVendorList(user?.companyId);
      // setassignedVendorDropdown(
      //   response?.data?.filter((f) => f.isActive) ?? []
      // );
      if (vendorId > 0) {
        const response = await vishwamApi.GetVendorDropdown();
        setassignedVendorDropdown(
          response?.data?.filter((f) => f.isActive && f.id === vendorId) ?? []
        );
      } else {
        const response = await vishwamApi.GetVendorDropdown2(searchText);
        setassignedVendorDropdown(
          response?.data?.filter((f) => f.isActive) ?? []
        );
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getAssetAcknowledgeConditionDropdown = async () => {
    try {
      const response = await assetService.getStatusDropdown(1010);
      setAssetAcknowledgeConditionDropdown(response.data ?? []);
    } catch (error) {
      console.log(error);
    }
  };

  const getReceivedByUserDropdown = async () => {
    try {
      const response = await vishwamApi.getUserList();
      setRecievedByUserDropdown(response.data ?? []);
    } catch (error) {
      console.log(error);
    }
  };

  const getCustodian1DepartmentDropdown = async () => {
    try {
      const response = await vishwamApi.getDepartmentDropdown(user?.companyId);
      setCustodian1DepartmentDropdown(response?.data ?? []);
    } catch (error) {
      console.log(error);
    }
  };

  const getCustodian1UserDropdown = async (custodian1DeptId) => {
    try {
      const response = await vishwamApi.getUserDrodpownByDepartmentd(
        custodian1DeptId,
        user?.companyId
      );
      setCustodian1UserDropdown(response?.data ?? []);
    } catch (error) {
      console.log(error);
    }
  };

  const getCustodian2DepartmentDropdown = async () => {
    try {
      const response = await vishwamApi.getDepartmentDropdown(user?.companyId);
      setCustodian2DepartmentDropdown(response?.data ?? []);
    } catch (error) {
      console.log(error);
    }
  };

  const getCustodian2UserDropdown = async (custodian2DeptId) => {
    try {
      const response = await vishwamApi.getUserDrodpownByDepartmentd(
        custodian2DeptId,
        user?.companyId
      );
      setCustodian2UserDropdown(response?.data ?? []);
    } catch (error) {
      console.log(error);
    }
  };

  const getCustodian3DepartmentDropdown = async () => {
    try {
      const response = await vishwamApi.getDepartmentDropdown(user?.companyId);
      setCustodian3DepartmentDropdown(response?.data ?? []);
    } catch (error) {
      console.log(error);
    }
  };

  const getCustodian3UserDropdown = async (custodian3DeptId) => {
    try {
      const response = await vishwamApi.getUserDrodpownByDepartmentd(
        custodian3DeptId,
        user?.companyId
      );
      setCustodian3UserDropdown(response?.data ?? []);
    } catch (error) {
      console.log(error);
    }
  };

  const getAssignDepartmentDropdown = async () => {
    try {
      const response = await vishwamApi.getDepartmentDropdown(user?.companyId);
      setAssignDepartmentDropdown(response?.data ?? []);
    } catch (error) {
      console.log(error);
    }
  };

  const getAssignUserDropdown = async (assignDeptId) => {
    try {
      const response = await vishwamApi.getUserDrodpownByDepartmentd(
        assignDeptId,
        user?.companyId
      );
      setAssignUserDropdown(response?.data ?? []);
    } catch (error) {
      console.log(error);
    }
  };

  const getBase64 = (file) => {
    if (!file) {
      return "";
    }
    return new Promise((resolve) => {
      let baseURL = "";
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        baseURL = reader.result;
        resolve(baseURL);
      };
    });
  };

  const handleOnAssetAcknowledgeFileUpload = (e) => {
    try {
      const file = e?.target?.files[0];
      let err = { ...errors };
      err.acknowledgeAttachmentValidation = "";
      setAssetAcknowledgeAttachment((prev) => ({
        ...prev,
        fileName: file?.name ?? "",
        fileType: file?.type ?? "",
        fileSize: file?.size ?? 0,
      }));
      getBase64(file).then((result) => {
        file["base64"] = result;
        setAssetAcknowledgeAttachment((prev) => ({
          ...prev,
          fileData: result,
          file,
        }));
      });
      setErrors(err);
    } catch (error) {
      console.log(error);
    }
  };

  const isValidAcknowledgeData = () => {
    let isValid = true;
    try {
      let err = { ...errors };
      err.acknowledgeAttachmentValidation = "";
      err.recievedByUserValidation = "";
      err.assetAcknowledgeConditionValidation = "";
      err.acknowledgeNoteValidation = "";
      err.cust1DeptValidation = "";
      err.cust2DeptValidation = "";
      err.cust3DeptValidation = "";
      err.assignDeptValidation = "";
      err.cust1UserValidation = "";
      err.cust2UserValidation = "";
      err.cust3UserValidation = "";
      err.assignUserValidation = "";
      err.assignTypeValidation = "";
      err.assignVendorNameValidation = "";
      err.assignVendorValidation = "";

      if (!assetAcknowledgeAttachment.fileName) {
        isValid = false;
        err.acknowledgeAttachmentValidation = "Please upload file.";
      }
      if (state.recievedByUserId === 0) {
        isValid = false;
        err.recievedByUserValidation = "Please select user.";
      }
      if (state.assetAcknowledgeConditionId === 0) {
        isValid = false;
        err.assetAcknowledgeConditionValidation = "Please select status.";
      }
      if (!state.acknowledgeNote) {
        isValid = false;
        err.acknowledgeNoteValidation = "Please enter note.";
      }
      if (state.rowData?.actionTypeId === 1) {
        if (state.cust1DeptId === 0) {
          isValid = false;
          err.cust1DeptValidation = "Please select department (custodian 1).";
        }
        if (state.cust2DeptId === 0) {
          isValid = false;
          err.cust2DeptValidation = "Please select department (custodian 2).";
        }
        if (state.cust3DeptId === 0) {
          isValid = false;
          err.cust3DeptValidation = "Please select department (custodian 3).";
        }
        if (state.assignTypeId === 0) {
          isValid = false;
          err.assignTypeValidation = "Please select assign to.";
        }
        if (
          (state.assignTypeId === 1 || state.assignTypeId === 2) &&
          state.assignDeptId === 0
        ) {
          isValid = false;
          err.assignDeptValidation = "Please select department.";
        }
        if (state.cust1UserId === 0) {
          isValid = false;
          err.cust1UserValidation = "Please select custodian 1.";
        }
        if (state.cust2UserId === 0) {
          isValid = false;
          err.cust2UserValidation = "Please select custodian 2.";
        }
        if (state.cust3UserId === 0) {
          isValid = false;
          err.cust3UserValidation = "Please select custodian 3.";
        }
        if (
          (state.assignTypeId === 1 || state.assignTypeId === 2) &&
          state.assignUserId === 0
        ) {
          isValid = false;
          err.assignUserValidation = "Please select user.";
        }
        if (
          (state.assignTypeId === 1 || state.assignTypeId === 2) &&
          state.assignUserId === state.assetAssignedId
        ) {
          isValid = false;
          err.assignUserValidation = "Please change assign to user.";
        }
        if (state.assignTypeId === 3 && state.assignVendorId === 0) {
          isValid = false;
          err.assignVendorValidation = "Please select vendor.";
        }
        if (state.assignTypeId === 3 && !state.assignVendorName) {
          isValid = false;
          err.assignVendorNameValidation = "Please enter vendor name.";
        }
      }
      setErrors(err);
    } catch (error) {
      console.log(error);
    }
    return isValid;
  };

  const handleOnAcknowledgeAsset = async (e, flagAck) => {
    e.preventDefault();
    try {
      if (isValidAcknowledgeData()) {
        let confirmationQuestion = "";
        if (flagAck === 1) {
          confirmationQuestion = `<span style='font-size:16px;'>Are you sure want to acknowledge and approve this ${state.rowData?.actionTypeId === 1
              ? `asset movement?`
              : state.rowData?.actionTypeId === 2
                ? `asset purchase?`
                : state.rowData?.actionTypeId === 3
                  ? `asset hire?`
                  : ``
            }</span>`;
        }
        else {
          confirmationQuestion = `<span style='font-size:16px;'>Are you sure want to acknowledge this ${state.rowData?.actionTypeId === 1
              ? `asset movement?`
              : state.rowData?.actionTypeId === 2
                ? `asset purchase?`
                : state.rowData?.actionTypeId === 3
                  ? `asset hire?`
                  : ``
            }</span>`;
        }
        let isConfirmed = await askConfirmation(
          confirmationQuestion,
          "Yes",
          "No"
        );
        if (!isConfirmed) return;
        setState((prev) => ({ ...prev, isAcknowledged: true }));
        let body = {
          assetAcknowledgeId: state.rowData?.id,
          acknowledgedBy: state.recievedByUserId,
          assetConditionId: state.assetAcknowledgeConditionId,
          actionTypeId: state.rowData?.actionTypeId,
          assetAcknowledgeNote: state.acknowledgeNote,
          assignTypeId: state.assignTypeId,
          custodian1DeptId: state.cust1DeptId,
          custodian2DeptId: state.cust2DeptId,
          custodian3DeptId: state.cust3DeptId,
          assignDeptId: state.assignDeptId,
          custodian1UserId: state.cust1UserId,
          custodian2UserId: state.cust2UserId,
          custodian3UserId: state.cust3UserId,
          assignUserId: state.assignUserId,
          assignVendorId: state.assignVendorId,
          assignVendorName: state.assignVendorName,
          fileName: assetAcknowledgeAttachment.fileName,
          fileData: assetAcknowledgeAttachment.fileData,
          fileType: assetAcknowledgeAttachment.fileType,
          fileSize: assetAcknowledgeAttachment.fileSize,
          userId: user?.userId,
          statusId:
            flagAck === 1
              ? AssetSubStatus.AssetAcknowledged
              : AssetSubStatus.AssetAcknowledgePending,
          locationName: state.rowData?.locationName ?? "",
        };
        const response = await assetService.acknowledgeAsset(body);
        isConfirmed = await showResponseMessage(response);
        setState((prev) => ({ ...prev, isAcknowledged: false }));
        if (response?.isSuccess) {
          handleOnCloseAcknowledgeModal();
          setState((prevState) => ({
            ...prevState,
            isCompleteLoading: true,
          }));
          await getAssetAcknowledgeLst(0, user?.userId);
          setState((prevState) => ({
            ...prevState,
            isCompleteLoading: false,
          }));
        }
      }
    } catch (error) {
      setState((prev) => ({ ...prev, isAcknowledged: false }));
      console.log(error);
    }
  };

  const handleOnCloseAcknowledgeModal = () => {
    try {
      setState((prev) => ({
        ...prev,
        isAcknowledged: false,
        isAcknowledgeModalOpen: false,
        rowData: null,
        assetAcknowledgeConditionId: 0,
        recievedByUserId: user?.userId ?? 0,
        recievedByUserName: "",
        acknowledgeNote: "",
        cust1DeptId: 0,
        cust2DeptId: 0,
        cust3DeptId: 0,
        assignDeptId: 0,
        cust1UserId: 0,
        cust2UserId: 0,
        cust3UserId: 0,
        assignUserId: 0,
        assignTypeId: 0,
        assignVendorId: 0,
        assignVendorName: "",
      }));
      setAssetAcknowledgeAttachment((prev) => ({
        ...prev,
        fileName: "",
        fileType: "",
        fileSize: 0,
        fileData: "",
      }));
      setAssetAcknowledgeConditionDropdown([]);
      setRecievedByUserDropdown([]);
      setCustodian1DepartmentDropdown([]);
      setCustodian2DepartmentDropdown([]);
      setCustodian3DepartmentDropdown([]);
      setAssignDepartmentDropdown([]);
      setCustodian1UserDropdown([]);
      setCustodian2UserDropdown([]);
      setCustodian3UserDropdown([]);
      setAssignUserDropdown([]);
      setAssignTypeDropdown([]);
      setassignedVendorDropdown([]);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div className="content">
        <div className="card">
          <div className="card-body">
            <DataGrid
              ref={refDataGrid}
              keyExpr="id"
              dataSource={assetAcknowledgeDataSourceLst}
              showColumnLines={false}
              showRowLines={true}
              showBorders={true}
              allowColumnResizing={false}
              allowColumnReordering={true}
              columnAutoWidth={true}
              onToolbarPreparing={(e) => {
                e.toolbarOptions.items.unshift({
                  location: "before",
                  template: "toolbarRefreshTemplate",
                });
              }}
            >
              <Column
                dataField="id"
                width={170}
                caption=""
                allowExporting={false}
                allowFiltering={false}
                allowSearch={false}
                allowSorting={false}
                cellRender={(cellData) => {
                  const idPrefix = `icon-${cellData?.data?.id}`;
                  return (
                    <>
                      <div style={{ display: "flex" }}>
                        {/* {props?.featurePermission?.canView && (
                          <>
                            <span>
                              <IconWithTooltip
                                id={`${idPrefix}-view`}
                                className="iconify-size mr-1"
                                title="View"
                                tooltip="View"
                                icon="solar:document-text-outline"
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  if (cellData?.data?.actionTypeId === 1) {
                                    navigate("/asset-movement-preview", {
                                      state: {
                                        requestMovementId:
                                          cellData?.data?.assetMovementId,
                                        movementIndentNo:
                                          cellData?.data?.referenceNo,
                                        sourceUrl: "AcknowledgeAssetMovement",
                                        isReport: false,
                                      },
                                    });
                                  } else if (
                                    cellData?.data?.actionTypeId === 2 ||
                                    cellData?.data?.actionTypeId === 3
                                  ) {
                                    navigate(
                                      cellData?.data?.quotationTypeId === 1
                                        ? "/asset-purchase-preview"
                                        : "/asset-hire-preview",
                                      {
                                        state: {
                                          requestQuotationId:
                                            cellData?.data?.assetQuotationId,
                                          quotationIndentNo:
                                            cellData?.data?.referenceNo,
                                          quotationTypeId:
                                            cellData?.data?.quotationTypeId,
                                          sourceUrl:
                                            cellData?.data?.quotationTypeId ===
                                            1
                                              ? "AcknowledgeRequestAssetPurchase"
                                              : cellData?.data
                                                  ?.quotationTypeId === 2
                                              ? "AcknowledgeRequestAssetHire"
                                              : "",
                                          isReport: false,
                                        },
                                      }
                                    );
                                  } else if (
                                    cellData?.data?.actionTypeId === 4
                                  ) {
                                    navigate(
                                      "/material-movement-order-preview",
                                      {
                                        state: {
                                          requestMovementId:
                                            cellData?.data
                                              ?.materialMovementOrderId,
                                          materialMovementOrderIndentNo:
                                            cellData?.data?.referenceNo,
                                          sourceUrl:
                                            "AcknowledgeMaterialMovementOrder",
                                          isReport: false,
                                        },
                                      }
                                    );
                                  }
                                }}
                              />
                            </span>
                          </>
                        )} */}
                        {/* &nbsp; */}
                        {/* {props?.featurePermission?.canView && (
                          <>
                            <span>
                              <IconWithTooltip
                                id={`${idPrefix}-view`}
                                className="iconify-size mr-1"
                                title="View"
                                tooltip="View"
                                icon="solar:document-text-outline"
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  navigate("/viewAssetAcknowledge", {
                                    state: {
                                      assetAcknowledgeId: cellData?.data?.id,
                                      assetId: cellData?.data?.allocatedAssetId,
                                      data: cellData?.data,
                                      sourceUrl: "AcknowledgeAssetMovement",
                                    },
                                  });
                                }}
                              />
                            </span>
                            &nbsp;&nbsp;
                          </>
                        )} */}
                        {cellData?.data?.requestActionAllowed && (
                          <>
                            <span>
                              {(cellData?.data?.actionTypeId === 1 ||
                                cellData?.data?.actionTypeId === 4 ||
                                cellData?.data?.assetStatusId ===
                                  parseInt(AssetSubStatus.Onboarded)) && (
                                <>
                                  {cellData?.data?.statusId ===
                                  Number(
                                    AssetSubStatus.AssetAcknowledgePending
                                  ) ? (
                                    <>
                                      <button
                                        style={{ cursor: "pointer" }}
                                        type="button"
                                        title="Acknowledge"
                                        className="btn btn-primary btn-sm-1"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          try {
                                            setState((prev) => ({
                                              ...prev,
                                              isAcknowledgeModalOpen: true,
                                              rowData: cellData?.data ?? null,
                                              recievedByUserId:
                                                cellData?.data?.requestedBy ??
                                                user?.userId,
                                              // recievedByUserId:
                                              //   cellData?.data?.acknowledgedBy ??
                                              //   user?.userId,
                                              assetAcknowledgeConditionId:
                                                cellData?.data
                                                  ?.acknowledgedAssetStatusId ??
                                                0,
                                              acknowledgeNote:
                                                cellData?.data
                                                  ?.acknowledgedNote ?? "",
                                              cust1DeptId:
                                                cellData?.data
                                                  ?.custodian1DeptId ?? 0,
                                              cust2DeptId:
                                                cellData?.data
                                                  ?.custodian2DeptId ?? 0,
                                              cust3DeptId:
                                                cellData?.data
                                                  ?.custodian3DeptId ?? 0,
                                              assignDeptId:
                                                cellData?.data?.assignDeptId ??
                                                0,
                                              cust1UserId:
                                                cellData?.data
                                                  ?.custodian1UserId ?? 0,
                                              cust2UserId:
                                                cellData?.data
                                                  ?.custodian2UserId ?? 0,
                                              cust3UserId:
                                                cellData?.data
                                                  ?.custodian3UserId ?? 0,
                                              assignUserId:
                                                cellData?.data?.assignUserId ??
                                                0,
                                              assignTypeId:
                                                cellData?.data?.assignTypeId ??
                                                0,
                                              assignVendorId:
                                                cellData?.data
                                                  ?.assignVendorId ?? 0,
                                              assignVendorName:
                                                cellData?.data
                                                  ?.assignVendorName ?? "",
                                              assignValidUserId:
                                                cellData?.data?.assignUserId ??
                                                0,
                                              assetAssignedId:
                                                cellData?.data
                                                  ?.assetAssignedId ?? 0,
                                              assetAssignDeptId:
                                                cellData?.data
                                                  ?.assetAssignDeptId ?? 0,
                                              assetAssignTypeId:
                                                cellData?.data
                                                  ?.assetAssignTypeId ?? 0,
                                            }));
                                            setAssetAcknowledgeAttachment(
                                              (prev) => ({
                                                ...prev,
                                                fileName:
                                                  cellData?.data
                                                    ?.assetAcknowledgeFileName ??
                                                  "",
                                              })
                                            );
                                            let err = { ...errors };
                                            err.assetAcknowledgeConditionValidation =
                                              "";
                                            err.recievedByUserValidation = "";
                                            err.acknowledgeNoteValidation = "";
                                            err.acknowledgeAttachmentValidation =
                                              "";
                                            err.cust1DeptValidation = "";
                                            err.cust2DeptValidation = "";
                                            err.cust3DeptValidation = "";
                                            err.assignDeptValidation = "";
                                            err.cust1UserValidation = "";
                                            err.cust2UserValidation = "";
                                            err.cust3UserValidation = "";
                                            err.assignUserValidation = "";
                                            err.assignTypeValidation = "";
                                            err.assignVendorNameValidation = "";
                                            err.assignVendorValidation = "";
                                            setErrors(err);
                                          } catch (error) {
                                            console.log(error);
                                          }
                                        }}
                                      >
                                        <Icon
                                          className="iconify-size mr-1"
                                          icon="fluent:check-20-filled"
                                          width="14"
                                          height="14"
                                        />
                                        &nbsp;Acknowledge
                                      </button>
                                    </>
                                  ) : (
                                    <>
                                      <button
                                        style={{ cursor: "pointer" }}
                                        type="button"
                                        title="Acknowledged"
                                        className="btn btn-primary btn-sm-1"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          try {
                                            setState((prev) => ({
                                              ...prev,
                                              isAcknowledgeModalOpen: true,
                                              rowData: cellData?.data ?? null,
                                              recievedByUserId:
                                                cellData?.data
                                                  ?.acknowledgedBy ??
                                                user?.userId,
                                              assetAcknowledgeConditionId:
                                                cellData?.data
                                                  ?.acknowledgedAssetStatusId ??
                                                0,
                                              acknowledgeNote:
                                                cellData?.data
                                                  ?.acknowledgedNote ?? "",
                                              cust1DeptId:
                                                cellData?.data
                                                  ?.custodian1DeptId ?? 0,
                                              cust2DeptId:
                                                cellData?.data
                                                  ?.custodian2DeptId ?? 0,
                                              cust3DeptId:
                                                cellData?.data
                                                  ?.custodian3DeptId ?? 0,
                                              assignDeptId:
                                                cellData?.data?.assignDeptId ??
                                                0,
                                              cust1UserId:
                                                cellData?.data
                                                  ?.custodian1UserId ?? 0,
                                              cust2UserId:
                                                cellData?.data
                                                  ?.custodian2UserId ?? 0,
                                              cust3UserId:
                                                cellData?.data
                                                  ?.custodian3UserId ?? 0,
                                              assignUserId:
                                                cellData?.data?.assignUserId ??
                                                0,
                                              assignTypeId:
                                                cellData?.data?.assignTypeId ??
                                                0,
                                              assignVendorId:
                                                cellData?.data
                                                  ?.assignVendorId ?? 0,
                                              assignVendorName:
                                                cellData?.data
                                                  ?.assignVendorName ?? "",
                                            }));
                                            setAssetAcknowledgeAttachment(
                                              (prev) => ({
                                                ...prev,
                                                fileName:
                                                  cellData?.data
                                                    ?.assetAcknowledgeFileName ??
                                                  "",
                                              })
                                            );
                                            let err = { ...errors };
                                            err.assetAcknowledgeConditionValidation =
                                              "";
                                            err.recievedByUserValidation = "";
                                            err.acknowledgeNoteValidation = "";
                                            err.acknowledgeAttachmentValidation =
                                              "";
                                            err.cust1DeptValidation = "";
                                            err.cust2DeptValidation = "";
                                            err.cust3DeptValidation = "";
                                            err.assignDeptValidation = "";
                                            err.cust1UserValidation = "";
                                            err.cust2UserValidation = "";
                                            err.cust3UserValidation = "";
                                            err.assignUserValidation = "";
                                            err.assignTypeValidation = "";
                                            err.assignVendorNameValidation = "";
                                            err.assignVendorValidation = "";
                                            setErrors(err);
                                          } catch (error) {
                                            console.log(error);
                                          }
                                        }}
                                      >
                                        <Icon
                                          className="iconify-size mr-1"
                                          icon="ph:check-fill"
                                          width="14"
                                          height="14"
                                        />
                                        &nbsp;Acknowledged
                                      </button>
                                    </>
                                  )}
                                </>
                              )}
                            </span>
                          </>
                        )}
                      </div>
                    </>
                  );
                }}
              />
              <Column
                dataField="actionTypeName"
                caption="Source"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
              />
              <Column
                dataField="acknowledgeIndentNo"
                caption="Asset Acknowledge Indent No"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
              />
              <Column
                dataField="assetRequestSubNo"
                caption="Asset Request No"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
              />
              <Column
                dataField="referenceNo"
                caption="Order No"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
              />
              <Column
                dataField="acknowledgeDate"
                caption="Acknowledgement Date"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
                dataType="date"
                format={DefaultDateFormat.GridDayMonthYearDateFormat}
              />
              <Column
                dataField="statusName"
                caption="Status"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
                cellRender={(e) => {
                  let color = "";
                  if (
                    e.data?.statusId ===
                    Number(AssetSubStatus.AssetAcknowledgePending)
                  ) {
                    color = "#afad1eff";
                  } else if (
                    e.data?.statusId ===
                    Number(AssetSubStatus.AssetAcknowledged)
                  ) {
                    color = "#16b36aff";
                  }

                  var lastUpdatedDate = "";
                  if (!e?.data?.updatedOn) {
                    lastUpdatedDate = moment(e?.data?.createdDate).format(DefaultDateFormat.MomentDisplayDateTimeAMPMFullFormat).toString();
                  }
                  else {
                    const parsedDate = new Date(e?.data?.updatedOn);
                    if (isNaN(parsedDate.getTime())) {
                      lastUpdatedDate = moment(e?.data?.updatedDate).format(DefaultDateFormat.MomentDisplayDateTimeAMPMFullFormat).toString();
                    }
                    const minDate = new Date("0001-01-01T00:00:00");
                    if (parsedDate.getTime() === minDate.getTime()) {
                      lastUpdatedDate = moment(e?.data?.createdDate).format(DefaultDateFormat.MomentDisplayDateTimeAMPMFullFormat).toString();
                    }
                    else {
                      lastUpdatedDate = moment(e?.data?.updatedDate).format(DefaultDateFormat.MomentDisplayDateTimeAMPMFullFormat).toString();
                    }
                  }
                  return (
                    <div>
                      <span style={{ color }}>{e.data?.statusName}</span>
                      <br />
                      <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                        {lastUpdatedDate}
                      </div>
                    </div>
                  );
                }}
              />
              <Column
                dataField="allocatedAssetName"
                caption="Asset Description"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
                calculateCellValue={(data) => {
                  return `${data?.allocatedAssetName || ""} ${
                    data?.allocatedAssetSerialNo || ""
                  }`;
                }}
                cellRender={(data) => {
                  return (
                    <>
                      <span>{data?.data?.allocatedAssetName ?? ""}</span>
                      {data?.data?.allocatedAssetSerialNo && (
                        <>
                          <br />
                          <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                            {data?.data?.allocatedAssetSerialNo ?? ""}
                          </div>
                        </>
                      )}
                    </>
                  );
                }}
              />
              <Column
                dataField="categoryName"
                caption="Category"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
                calculateCellValue={(data) => {
                  return `${data?.categoryName || ""} ${
                    data?.subCategoryName || ""
                  }`;
                }}
                cellRender={(data) => {
                  return (
                    <>
                      <span>{data?.data?.categoryName ?? ""}</span>
                      {data?.data?.subCategoryName && (
                        <>
                          <br />
                          <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                            {data?.data?.subCategoryName ?? ""}
                          </div>
                        </>
                      )}
                    </>
                  );
                }}
              />
              <Column
                dataField="vseFleetId"
                caption="VSE Fleet Id"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
              />
              <Column
                dataField="fromUserFullName"
                caption="From"
                visible={false}
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
                calculateCellValue={(data) => {
                  return `${data?.fromUserFullName || ""} ${
                    data?.fromUserFullName || ""
                  }`;
                }}
                cellRender={(data) => {
                  return (
                    <>
                      <span>{data?.data?.fromUserFullName ?? ""}</span>
                      {data?.data?.fromDepartment && (
                        <>
                          <br />
                          <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                            {data?.data?.fromDepartment ?? ""}
                          </div>
                        </>
                      )}
                    </>
                  );
                }}
              />
              <Column
                dataField="toUserFullName"
                caption="To"
                visible={false}
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
                calculateCellValue={(data) => {
                  return `${data?.toUserFullName || ""} ${
                    data?.toDepartment || ""
                  }`;
                }}
                cellRender={(data) => {
                  return (
                    <>
                      <span>{data?.data?.toUserFullName ?? ""}</span>
                      {data?.data?.toDepartment && (
                        <>
                          <br />
                          <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                            {data?.data?.toDepartment ?? ""}
                          </div>
                        </>
                      )}
                    </>
                  );
                }}
              />
              <Column
                dataField="fromProjectName"
                caption="Project"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
                calculateCellValue={(data) => {
                  return `${data?.fromProjectName || ""} ${
                    data?.toProjectName || ""
                  }`;
                }}
                cellRender={(data) => {
                  return (
                    <>
                      <span>{data?.data?.fromProjectName ?? ""}</span>
                      {data?.data?.toProjectName && (
                        <>
                          <br />
                          <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                            {data?.data?.toProjectName ?? ""}
                          </div>
                        </>
                      )}
                    </>
                  );
                }}
              />
              <Column
                dataField="transportationName"
                caption="Transportation Type"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
              />
              <Column
                dataField="transportVehicleNo"
                caption="Vehicle No."
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
              />
              <Column
                dataField="transportVendorName"
                caption="Vendor Name"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
                visible={false}
              />              
              {/* <Column
                dataField="createdDate"
                caption="Created On"
                allowSearch={true}
                allowFiltering={false}
                calculateCellValue={(data) => {
                  return `${data?.createdDate || ""} ${
                    data?.createdByUserFullName || ""
                  }`;
                }}
                cellRender={(data) => {
                  if (data?.data?.createdDate) {
                    return (
                      <>
                        <span>
                          {moment(data?.data?.createdDate).format(
                            "DD/MM/YYYY"
                          ) +
                            " " +
                            moment(data?.data?.createdDate).format("LT") ?? ""}
                        </span>
                        <br />
                        <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                          {data?.data?.createdByUserFullName ?? ""}
                        </div>
                      </>
                    );
                  } else {
                    return "";
                  }
                }}
              />
              <Column
                dataField="updatedDate"
                caption="Last updated"
                allowSearch={true}
                allowFiltering={false}
                calculateCellValue={(data) => {
                  return `${data?.updatedDate || ""} ${
                    data?.updatedByUserFullName || ""
                  }`;
                }}
                cellRender={(data) => {
                  if (data?.data?.updatedDate) {
                    return (
                      <>
                        <span>
                          {moment(data?.data?.updatedDate).format(
                            "DD/MM/YYYY"
                          ) +
                            " " +
                            moment(data?.data?.updatedDate).format("LT") ?? ""}
                        </span>
                        <br />
                        <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                          {data?.data?.updatedByUserFullName ?? ""}
                        </div>
                      </>
                    );
                  } else {
                    return "";
                  }
                }}
              /> */}
              <Template
                name="toolbarRefreshTemplate"
                render={() => {
                  return (
                    <>
                      <button
                        style={{ cursor: "pointer" }}
                        type="button"
                        title="Refresh"
                        className="btn btn-outline-primary btn-sm"
                        onClick={async () => {
                          try {
                            setState((prevState) => ({
                              ...prevState,
                              isCompleteLoading: true,
                            }));
                            await getAssetAcknowledgeLst(0, user?.userId);
                          } catch (error) {
                            console.log(error);
                          } finally {
                            setState((prevState) => ({
                              ...prevState,
                              isCompleteLoading: false,
                            }));
                          }
                        }}
                      >
                        <i className="fas fa-sync-alt"></i>
                        &nbsp;&nbsp;Refresh
                      </button>
                    </>
                  );
                }}
              />
              <HeaderFilter visible={false} />
              <SearchPanel
                visible={true}
                highlightCaseSensitive={true}
                width={240}
                placeholder="Search..."
              />
              <Paging defaultPageSize={10} />
              <Pager
                allowedPageSizes={[10, 15, 20, 50, 100]}
                showPageSizeSelector={true}
                showInfo={true}
                visible={true}
                showNavigationButtons={true}
              />
              <Export enabled={true} fileName="Asset Acknowledgement" />
            </DataGrid>
          </div>
        </div>
      </div>

      {/* For Acknowledging Asset */}
      <Modal
        ariaHideApp={false}
        isOpen={state.isAcknowledgeModalOpen}
        onAfterOpen={async () => {
          await getAssetAcknowledgeConditionDropdown();
          await getReceivedByUserDropdown();
          await getCustodian1DepartmentDropdown();
          await getCustodian2DepartmentDropdown();
          await getCustodian3DepartmentDropdown();
          await getAssignDepartmentDropdown();
          await getCustodian1UserDropdown(state.cust1DeptId);
          await getCustodian2UserDropdown(state.cust2DeptId);
          await getCustodian3UserDropdown(state.cust3DeptId);
          await getAssignUserDropdown(state.assignDeptId);
          await getAssignTypeDropdown();
          await getAssignedVendorDropdown("", state.assignVendorId);
        }}
        className={"react-modal custom-modal-xlarge"}
        shouldCloseOnOverlayClick={false}
        contentLabel="Acknowledge Asset"
      >
        <div className="modal-header">
          <h6 className="modal-title">
            {`Acknowledge Asset - [${state.rowData?.acknowledgeIndentNo}] for ${state.rowData?.actionTypeName}`}
          </h6>
          <button
            type="button"
            className="close"
            onClick={() => {
              handleOnCloseAcknowledgeModal();
            }}
          >
            <span aria-hidden="true">x</span>
          </button>
        </div>
        <div className="modal-body">
          <div
            style={{ overflowy: "auto", height: "600px", overflowX: "hidden" }}
          >
            <div className="row">
              <div className="col-12 col-lg-3">
                <div className="form-group mb-3">
                  <label className="mb-0">Order No</label>
                  <p className="labelvalue">
                    {!state.rowData?.referenceNo
                      ? "NA"
                      : state.rowData?.referenceNo}
                  </p>
                </div>
              </div>
              <div className="col-12 col-lg-3">
                <div className="form-group mb-2">
                  <label className="mb-0">Asset Name</label>
                  <p className="labelvalue">
                    {!state.rowData?.allocatedAssetName
                      ? "NA"
                      : state.rowData?.allocatedAssetName}
                  </p>
                </div>
              </div>
              <div className="col-12 col-lg-3">
                <div className="form-group mb-2">
                  <label className="mb-0">Asset Serial No</label>
                  <p className="labelvalue">
                    {!state.rowData?.allocatedAssetSerialNo
                      ? "NA"
                      : state.rowData?.allocatedAssetSerialNo}
                  </p>
                </div>
              </div>
              <div className="col-12 col-lg-3">
                <div className="form-group mb-2">
                  <label className="mb-0">Group</label>
                  <p className="labelvalue">
                    {!state.rowData?.assetGroupName
                      ? "NA"
                      : state.rowData?.assetGroupName}
                  </p>
                </div>
              </div>
              <div className="col-12 col-lg-3">
                <div className="form-group mb-2">
                  <label className="mb-0">Category</label>
                  <p className="labelvalue">
                    {!state.rowData?.categoryName
                      ? "NA"
                      : state.rowData?.categoryName}
                  </p>
                </div>
              </div>
              <div className="col-12 col-lg-3">
                <div className="form-group mb-2">
                  <label className="mb-0">Sub Category</label>
                  <p className="labelvalue">
                    {!state.rowData?.subCategoryName
                      ? "NA"
                      : state.rowData?.subCategoryName}
                  </p>
                </div>
              </div>
              <div className="col-12 col-lg-3">
                <div className="form-group mb-2">
                  <label className="mb-0">VSE Fleet Id</label>
                  <p className="labelvalue">
                    {!state.rowData?.vseFleetId
                      ? "NA"
                      : state.rowData?.vseFleetId}
                  </p>
                </div>
              </div>
              <div className="col-12 col-lg-3">
                <div className="form-group mb-2">
                  <label className="mb-0">ERP Fleet Id</label>
                  <p className="labelvalue">
                    {!state.rowData?.erpFleetId
                      ? "NA"
                      : state.rowData?.erpFleetId}
                  </p>
                </div>
              </div>
              <div className="col-12 col-lg-3">
                <div className="form-group mb-2">
                  <label className="mb-0">Project</label>
                  <p className="labelvalue">
                    {!state.rowData?.assetProjectName
                      ? "NA"
                      : state.rowData?.assetProjectName}
                  </p>
                </div>
              </div>
              <div className="col-12 col-lg-3">
                <div className="form-group mb-2">
                  <label className="mb-0">Location</label>
                  <p className="labelvalue">
                    {!state.rowData?.locationName
                      ? "NA"
                      : state.rowData?.locationName}
                  </p>
                </div>
              </div>
              <div className="col-12 col-lg-3">
                <div className="form-group mb-2">
                  <label className="mb-0">Make</label>
                  <p className="labelvalue">
                    {!state.rowData?.assetMake
                      ? "NA"
                      : state.rowData?.assetMake}
                  </p>
                </div>
              </div>
              <div className="col-12 col-lg-3">
                <div className="form-group mb-2">
                  <label className="mb-0">Make Year</label>
                  <p className="labelvalue">
                    {!state.rowData?.assetMakeYear
                      ? "NA"
                      : state.rowData?.assetMakeYear}
                  </p>
                </div>
              </div>
              <div className="col-12 col-lg-3">
                <div className="form-group mb-2">
                  <label className="mb-0">Model</label>
                  <p className="labelvalue">
                    {!state.rowData?.assetModel
                      ? "NA"
                      : state.rowData?.assetModel}
                  </p>
                </div>
              </div>
              <div className="col-12 col-lg-3">
                <div className="form-group mb-2">
                  <label className="mb-0">Model Serial No</label>
                  <p className="labelvalue">
                    {!state.rowData?.assetModelModelSerialNo
                      ? "NA"
                      : state.rowData?.assetModelModelSerialNo}
                  </p>
                </div>
              </div>
              <div className="col-12 col-lg-3">
                <div className="form-group mb-2">
                  <label className="mb-0">Size</label>
                  <p className="labelvalue">
                    {!state.rowData?.assetSize
                      ? "NA"
                      : state.rowData?.assetSize}
                  </p>
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <div className="col-12 col-lg-4">
                <div className="form-group mb-2">
                  <label>
                    Received By&nbsp;<span className="text-danger">*</span>
                  </label>
                  <SelectBox
                    dataSource={recievedByUserDropdown}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    placeholder="Select received by"
                    name="recievedByUserDropdown"
                    displayExpr="name"
                    valueExpr="id"
                    value={state.recievedByUserId}
                    defaultValue={state.recievedByUserId}
                    showClearButton={true}
                    searchEnabled={true}
                    readOnly={
                      state.rowData?.statusId ===
                      Number(AssetSubStatus.AssetAcknowledged)
                    }
                    onSelectionChanged={(e) => {
                      let err = { ...errors };
                      err.recievedByUserValidation = "";
                      setErrors(err);
                      setState((prev) => ({
                        ...prev,
                        recievedByUserId: e?.selectedItem?.id ?? 0,
                        recievedByUserName: e?.selectedItem?.name ?? "",
                      }));
                    }}
                  />
                  {errors.recievedByUserValidation && (
                    <div className="text-danger">
                      {errors.recievedByUserValidation}
                    </div>
                  )}
                </div>
              </div>
              <div className="col-12 col-lg-4">
                <div className="form-group mb-2">
                  <label>
                    Asset Status&nbsp;<span className="text-danger">*</span>
                  </label>
                  <SelectBox
                    dataSource={assetAcknowledgeConditionDropdown}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    placeholder="Select status"
                    name="assetAcknowledgeConditionDropdown"
                    displayExpr="name"
                    valueExpr="id"
                    value={state.assetAcknowledgeConditionId}
                    defaultValue={state.assetAcknowledgeConditionId}
                    showClearButton={true}
                    searchEnabled={true}
                    readOnly={
                      state.rowData?.statusId ===
                      Number(AssetSubStatus.AssetAcknowledged)
                    }
                    onSelectionChanged={(e) => {
                      let err = { ...errors };
                      err.assetAcknowledgeConditionValidation = "";
                      setErrors(err);
                      setState((prev) => ({
                        ...prev,
                        assetAcknowledgeConditionId: e?.selectedItem?.id ?? 0,
                      }));
                    }}
                  />
                  {errors.assetAcknowledgeConditionValidation && (
                    <div className="text-danger">
                      {errors.assetAcknowledgeConditionValidation}
                    </div>
                  )}
                </div>
              </div>
              {state.rowData?.statusId ===
                Number(AssetSubStatus.AssetAcknowledgePending) && (
                <>
                  <div className="col-12 col-lg-4">
                    <div className="form-group mb-2">
                      <label>
                        File Upload&nbsp;<span className="text-danger">*</span>
                      </label>
                      <div className="input-group">
                        <div className="col-lg-12 custom-file">
                          <input
                            type="file"
                            name="fileName"
                            className="custom-file-input"
                            onChange={(e) => {
                              handleOnAssetAcknowledgeFileUpload(e);
                            }}
                          />
                          <label
                            style={{ height: "38px" }}
                            className="custom-file-label"
                          >
                            {assetAcknowledgeAttachment.fileName
                              ? assetAcknowledgeAttachment.fileName
                              : "Choose File"}
                          </label>
                          &nbsp;&nbsp;
                        </div>
                      </div>
                      {errors.acknowledgeAttachmentValidation && (
                        <div className="text-danger">
                          {errors.acknowledgeAttachmentValidation}
                        </div>
                      )}
                    </div>
                  </div>
                </>
              )}
              {state.rowData?.statusId ===
                Number(AssetSubStatus.AssetAcknowledged) && (
                <>
                  <div className="col-12 col-lg-4">
                    <div className="form-group mb-2">
                      <div>File Uploaded</div>
                      <a
                        style={{
                          cursor: "pointer",
                          color: "blue",
                          textAlign: "center",
                        }}
                        onClick={() => {
                          try {
                            let a = document.createElement("a");
                            a.href = state.rowData?.assetAcknowledgeFileUrl;
                            a.download =
                              state.rowData?.assetAcknowledgeFileName;
                            a.target = "_blank";
                            a.click();
                            document.body.removeChild(a);
                          } catch (error) {
                            console.log(error);
                          }
                        }}
                      >
                        <u>{state.rowData?.assetAcknowledgeFileName}</u>
                      </a>
                    </div>
                  </div>
                </>
              )}
            </div>
            {(state.rowData?.actionTypeId === 1 ||
              state.rowData?.actionTypeId === 2 ||
              state.rowData?.actionTypeId === 3) && (
              <>
                <br />
                <h6>
                  Custodian Information
                  <hr style={{ borderTop: "1px solid rgb(223 211 211)" }}></hr>
                </h6>
                <div className="row">
                  <div className="col-12 col-lg-3">
                    <div className="form-group mb-2">
                      <label>
                        Department (Custodian 1)&nbsp;
                        <span className="text-danger">*</span>
                      </label>
                      <SelectBox
                        dataSource={custodian1DepartmentDropdown}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        placeholder="Select department"
                        name="custodian1DepartmentDropdown"
                        displayExpr="departmentName"
                        valueExpr="id"
                        value={state.cust1DeptId}
                        defaultValue={state.cust1DeptId}
                        showClearButton={true}
                        disabled={true}
                        searchEnabled={true}
                        readOnly={
                          state.rowData?.actionTypeId === 2 ||
                          state.rowData?.actionTypeId === 3
                        }
                        onSelectionChanged={async (e) => {
                          let err = { ...errors };
                          err.cust1DeptValidation = "";
                          setErrors(err);
                          setState((prev) => ({
                            ...prev,
                            cust1DeptId: e?.selectedItem?.id ?? 0,
                            cust1UserId: 0,
                          }));
                          setCustodian1UserDropdown([]);
                          if (e?.selectedItem?.id > 0) {
                            await getCustodian1UserDropdown(
                              e?.selectedItem?.id
                            );
                          }
                        }}
                      />
                      {errors.cust1DeptValidation && (
                        <div className="text-danger">
                          {errors.cust1DeptValidation}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-lg-3">
                    <div className="form-group mb-2">
                      <label>
                        Custodian 1&nbsp;<span className="text-danger">*</span>
                      </label>
                      <SelectBox
                        // dataSource={custodian1UserDropdown?.filter(
                        //   (f) =>
                        //     f.id !== state.cust2UserId &&
                        //     f.id !== state.cust3UserId
                        // )}
                        dataSource={custodian1UserDropdown}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        placeholder="Select custodian 1"
                        name="custodian1UserDropdown"
                        displayExpr="name"
                        valueExpr="id"
                        value={state.cust1UserId}
                        defaultValue={state.cust1UserId}
                        showClearButton={true}
                        disabled={true}
                        searchEnabled={true}
                        readOnly={
                          state.rowData?.actionTypeId === 2 ||
                          state.rowData?.actionTypeId === 3
                        }
                        onSelectionChanged={(e) => {
                          let err = { ...errors };
                          err.cust1UserValidation = "";
                          setErrors(err);
                          setState((prev) => ({
                            ...prev,
                            cust1UserId: e?.selectedItem?.id ?? 0,
                          }));
                        }}
                      />
                      {errors.cust1UserValidation && (
                        <div className="text-danger">
                          {errors.cust1UserValidation}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-lg-3">
                    <div className="form-group mb-2">
                      <label>
                        Department (Custodian 2)&nbsp;
                        <span className="text-danger">*</span>
                      </label>
                      <SelectBox
                        dataSource={custodian2DepartmentDropdown}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        placeholder="Select department"
                        name="custodian2DepartmentDropdown"
                        displayExpr="departmentName"
                        valueExpr="id"
                        value={state.cust2DeptId}
                        defaultValue={state.cust2DeptId}
                        showClearButton={true}
                        disabled={true}
                        searchEnabled={true}
                        readOnly={
                          state.rowData?.actionTypeId === 2 ||
                          state.rowData?.actionTypeId === 3
                        }
                        onSelectionChanged={async (e) => {
                          let err = { ...errors };
                          err.cust2DeptValidation = "";
                          setErrors(err);
                          setState((prev) => ({
                            ...prev,
                            cust2DeptId: e?.selectedItem?.id ?? 0,
                            cust2UserId: 0,
                          }));
                          setCustodian2UserDropdown([]);
                          if (e?.selectedItem?.id > 0) {
                            await getCustodian2UserDropdown(
                              e?.selectedItem?.id
                            );
                          }
                        }}
                      />
                      {errors.cust2DeptValidation && (
                        <div className="text-danger">
                          {errors.cust2DeptValidation}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-lg-3">
                    <div className="form-group mb-2">
                      <label>
                        Custodian 2&nbsp;<span className="text-danger">*</span>
                      </label>
                      <SelectBox
                        // dataSource={custodian2UserDropdown?.filter(
                        //   (f) =>
                        //     f.id !== state.cust1UserId &&
                        //     f.id !== state.cust3UserId
                        // )}
                        dataSource={custodian2UserDropdown}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        placeholder="Select custodian 2"
                        name="custodian2UserDropdown"
                        displayExpr="name"
                        valueExpr="id"
                        value={state.cust2UserId}
                        defaultValue={state.cust2UserId}
                        showClearButton={true}
                        disabled={true}
                        searchEnabled={true}
                        readOnly={
                          state.rowData?.actionTypeId === 2 ||
                          state.rowData?.actionTypeId === 3
                        }
                        onSelectionChanged={(e) => {
                          let err = { ...errors };
                          err.cust2UserValidation = "";
                          setErrors(err);
                          setState((prev) => ({
                            ...prev,
                            cust2UserId: e?.selectedItem?.id ?? 0,
                          }));
                        }}
                      />
                      {errors.cust2UserValidation && (
                        <div className="text-danger">
                          {errors.cust2UserValidation}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-lg-3">
                    <div className="form-group mb-2">
                      <label>
                        Department (Custodian 3)&nbsp;
                        <span className="text-danger">*</span>
                      </label>
                      <SelectBox
                        dataSource={custodian3DepartmentDropdown}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        placeholder="Select department"
                        name="custodian3DepartmentDropdown"
                        displayExpr="departmentName"
                        valueExpr="id"
                        value={state.cust3DeptId}
                        defaultValue={state.cust3DeptId}
                        showClearButton={true}
                        disabled={false}
                        searchEnabled={true}
                        // readOnly={
                        //   state.rowData?.actionTypeId === 2 ||
                        //   state.rowData?.actionTypeId === 3
                        // }
                        onSelectionChanged={async (e) => {
                          let err = { ...errors };
                          err.cust3DeptValidation = "";
                          setErrors(err);
                          setState((prev) => ({
                            ...prev,
                            cust3DeptId: e?.selectedItem?.id ?? 0,
                            cust3UserId: 0,
                          }));
                          setCustodian3UserDropdown([]);
                          if (e?.selectedItem?.id > 0) {
                            await getCustodian3UserDropdown(
                              e?.selectedItem?.id
                            );
                          }
                        }}
                      />
                      {errors.cust3DeptValidation && (
                        <div className="text-danger">
                          {errors.cust3DeptValidation}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-lg-3">
                    <div className="form-group mb-2">
                      <label>
                        Custodian 3&nbsp;<span className="text-danger">*</span>
                      </label>
                      <SelectBox
                        // dataSource={custodian3UserDropdown?.filter(
                        //   (f) =>
                        //     f.id !== state.cust1UserId &&
                        //     f.id !== state.cust2UserId
                        // )}
                        dataSource={custodian3UserDropdown}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        placeholder="Select custodian 3"
                        name="custodian3UserDropdown"
                        displayExpr="name"
                        valueExpr="id"
                        value={state.cust3UserId}
                        defaultValue={state.cust3UserId}
                        showClearButton={true}
                        disabled={false}
                        searchEnabled={true}
                        // readOnly={
                        //   state.rowData?.actionTypeId === 2 ||
                        //   state.rowData?.actionTypeId === 3
                        // }
                        onSelectionChanged={(e) => {
                          let err = { ...errors };
                          err.cust3UserValidation = "";
                          setErrors(err);
                          setState((prev) => ({
                            ...prev,
                            cust3UserId: e?.selectedItem?.id ?? 0,
                          }));
                        }}
                      />
                      {errors.cust3UserValidation && (
                        <div className="text-danger">
                          {errors.cust3UserValidation}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-lg-3">
                    <div className="form-group mb-2">
                      <label>
                        Assign To&nbsp;
                        <span className="text-danger">*</span>
                      </label>
                      <SelectBox
                        dataSource={assignTypeDropdown}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        placeholder="Select assign to"
                        name="assignTypeDropdown"
                        displayExpr="name"
                        valueExpr="id"
                        value={state.assignTypeId}
                        defaultValue={state.assignTypeId}
                        showClearButton={true}
                        disabled={false}
                        searchEnabled={true}
                        // readOnly={
                        //   state.rowData?.actionTypeId === 2 ||
                        //   state.rowData?.actionTypeId === 3
                        // }
                        onSelectionChanged={(e) => {
                          let err = { ...errors };
                          err.assignTypeValidation = "";
                          setErrors(err);
                          setState((prev) => ({
                            ...prev,
                            assignTypeId: e?.selectedItem?.id ?? 0,
                          }));
                        }}
                      />
                      {errors.assignTypeValidation && (
                        <div className="text-danger">
                          {errors.assignTypeValidation}
                        </div>
                      )}
                    </div>
                  </div>
                  {(state.assignTypeId === 1 || state.assignTypeId === 2) && (
                    <>
                      <div className="col-12 col-lg-3">
                        <div className="form-group mb-2">
                          <label>
                            Department&nbsp;
                            <span className="text-danger">*</span>
                          </label>
                          <SelectBox
                            dataSource={assignDepartmentDropdown}
                            className="basic-multi-select"
                            classNamePrefix="select"
                            placeholder="Select department"
                            name="assignDepartmentDropdown"
                            displayExpr="departmentName"
                            valueExpr="id"
                            value={state.assignDeptId}
                            defaultValue={state.assignDeptId}
                            showClearButton={true}
                            disabled={false}
                            searchEnabled={true}
                            // readOnly={
                            //   state.rowData?.actionTypeId === 2 ||
                            //   state.rowData?.actionTypeId === 3
                            // }
                            onSelectionChanged={async (e) => {
                              let err = { ...errors };
                              err.assignDeptValidation = "";
                              setErrors(err);
                              setState((prev) => ({
                                ...prev,
                                assignDeptId: e?.selectedItem?.id ?? 0,
                                assignUserId: 0,
                              }));
                              setAssignUserDropdown([]);
                              if (e?.selectedItem?.id > 0) {
                                await getAssignUserDropdown(
                                  e?.selectedItem?.id
                                );
                              }
                            }}
                          />
                          {errors.assignDeptValidation && (
                            <div className="text-danger">
                              {errors.assignDeptValidation}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-lg-3">
                        <div className="form-group mb-2">
                          <label>
                            User&nbsp;<span className="text-danger">*</span>
                          </label>
                          <SelectBox
                            // dataSource={assignUserDropdown?.filter(
                            //   (f) =>
                            //     f.id !== state.cust1UserId &&
                            //     f.id !== state.cust2UserId &&
                            //     f.id !== state.cust3UserId
                            // )}
                            dataSource={assignUserDropdown}
                            className="basic-multi-select"
                            classNamePrefix="select"
                            placeholder="Select user to assign"
                            name="assignUserDropdown"
                            displayExpr="name"
                            valueExpr="id"
                            value={state.assignUserId}
                            defaultValue={state.assignUserId}
                            showClearButton={true}
                            disabled={false}
                            searchEnabled={true}
                            // readOnly={
                            //   state.rowData?.actionTypeId === 2 ||
                            //   state.rowData?.actionTypeId === 3
                            // }
                            onSelectionChanged={(e) => {
                              let err = { ...errors };
                              err.assignUserValidation = "";
                              setErrors(err);
                              setState((prev) => ({
                                ...prev,
                                assignUserId: e?.selectedItem?.id ?? 0,
                              }));
                            }}
                          />
                          {errors.assignUserValidation && (
                            <div className="text-danger">
                              {errors.assignUserValidation}
                            </div>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                  {state.assignTypeId === 3 && (
                    <>
                      <div className="col-12 col-lg-3">
                        <div className="form-group mb-2">
                          <label>
                            Vendor&nbsp;<span className="text-danger">*</span>
                          </label>
                          <SelectBox
                            dataSource={assignedVendorDropdown}
                            className="basic-multi-select"
                            classNamePrefix="select"
                            placeholder="Select vendor"
                            name="assignedVendorDropdown"
                            displayExpr="name"
                            valueExpr="id"
                            value={state.assignVendorId}
                            defaultValue={state.assignVendorId}
                            showClearButton={true}
                            disabled={false}
                            searchEnabled={true}
                            onInput={(e) => {
                              const searchText = e?.event?.target?.value || "";
                              debouncedVendorSearch(searchText);
                            }}
                            // readOnly={
                            //   state.rowData?.actionTypeId === 2 ||
                            //   state.rowData?.actionTypeId === 3
                            // }
                            onSelectionChanged={(e) => {
                              let err = { ...errors };
                              err.assignVendorValidation = "";
                              setErrors(err);
                              setState((prev) => ({
                                ...prev,
                                assignVendorId: e?.selectedItem?.id ?? 0,
                              }));
                            }}
                          />
                          {errors.assignVendorValidation && (
                            <div className="text-danger">
                              {errors.assignVendorValidation}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-lg-3">
                        <div className="form-group mb-2">
                          <label>
                            vendor Name&nbsp;
                            <span className="text-danger">*</span>
                          </label>
                          <TextBox
                            name="assignVendorName"
                            className="form-control form-control-sm"
                            height={37}
                            placeholder="Enter vendor name"
                            showClearButton={true}
                            valueChangeEvent="keyup"
                            // readOnly={
                            //   state.rowData?.actionTypeId === 2 ||
                            //   state.rowData?.actionTypeId === 3
                            // }
                            onValueChanged={(e) => {
                              let err = { ...errors };
                              err.assignVendorNameValidation = "";
                              setErrors(err);
                              setState((prev) => ({
                                ...prev,
                                assignVendorName: e.value ?? "",
                              }));
                            }}
                            value={state.assignVendorName}
                          />
                          {errors.assignVendorNameValidation && (
                            <div className="text-danger">
                              {errors.assignVendorNameValidation}
                            </div>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </>
            )}
            <div className="row">
              <div className="col-12 col-lg-12">
                <div className="form-group mb-2">
                  <label>
                    Note&nbsp;<span className="text-danger">*</span>
                  </label>
                  <TextArea
                    readOnly={
                      state.rowData?.statusId ===
                      Number(AssetSubStatus.AssetAcknowledged)
                    }
                    className="form-control"
                    placeholder="Enter note"
                    showClearButton={true}
                    valueChangeEvent="keyup"
                    value={state.acknowledgeNote}
                    onValueChanged={(e) => {
                      let err = { ...errors };
                      err.acknowledgeNoteValidation = "";
                      setErrors(err);
                      setState((prev) => ({
                        ...prev,
                        acknowledgeNote: e.value,
                      }));
                    }}
                  />
                  {errors.acknowledgeNoteValidation && (
                    <div className="text-danger">
                      {errors.acknowledgeNoteValidation}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-primary btn-sm"
            title="Save"
            onClick={async (e) => {
              await handleOnAcknowledgeAsset(e, 0);
            }}
            disabled={state.isAcknowledged}
            hidden={
              state.rowData?.statusId ===
              Number(AssetSubStatus.AssetAcknowledged)
            }
          >
            <span title="Save">
              <i
                className={`fas fa-${
                  state.isAcknowledged ? `spinner fa-spin` : `check`
                }`}
              />
              &nbsp;&nbsp;Save
            </span>
          </button>
          &nbsp;&nbsp;
          <button
            type="button"
            className="btn btn-primary btn-sm"
            title="Update"
            onClick={async (e) => {
              await handleOnAcknowledgeAsset(e, 1);
            }}
            disabled={state.isAcknowledged}
            hidden={
              state.rowData?.statusId ===
              Number(AssetSubStatus.AssetAcknowledged)
            }
          >
            <span title="Update">
              <i
                className={`fas fa-${
                  state.isAcknowledged ? `spinner fa-spin` : `check`
                }`}
              />
              &nbsp;&nbsp;Acknowledge & Approve
            </span>
          </button>
          &nbsp;&nbsp;
          <button
            type="button"
            className="btn btn-outline-primary btn-sm"
            title="Cancel"
            onClick={() => {
              handleOnCloseAcknowledgeModal();
            }}
          >
            <i className="fas fa-times"></i>&nbsp;&nbsp;Cancel
          </button>
        </div>
      </Modal>

      {state.isCompleteLoading && (
        <Loader loadingMessage={state.loadingMessage} />
      )}
    </>
  );
}
